import { render, staticRenderFns } from "./counselorList.vue?vue&type=template&id=2fe61cb7&scoped=true&"
import script from "./counselorList.vue?vue&type=script&lang=ts&"
export * from "./counselorList.vue?vue&type=script&lang=ts&"
import style0 from "./counselorList.vue?vue&type=style&index=0&id=2fe61cb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe61cb7",
  null
  
)

export default component.exports